<!--<kendo-tabstrip [scrollable]="true" [tabPosition]="position4"  (tabSelect)="onHeaderTabSelected($event)">-->

<kendo-tabstrip  [tabPosition]="position4" class="k-tabstrip" (tabSelect)="onHeaderTabSelected($event)" >
  <kendo-tabstrip-tab title="{{orderDetailTxt.orderHeaderLbl?orderDetailTxt.orderHeaderLbl:orderDetail.orderHeaderLbl}}" [selected]="true">
    <ng-template kendoTabContent>

      <div class="header-details-section">
        <h4 class="fontInPwa">{{orderDetailsHeaderData?.jobName}}</h4>
        <!--<div class="row marginLeft-pwa">
          <div class="col-sm-4">
            <p>{{orderDetailTxt.soLbl?orderDetailTxt.soLbl:orderDetail.soLbl}}: {{orderDetailsHeaderData?.orderNumber}}</p> <p>{{orderDetailTxt.jobNumberLbl?orderDetailTxt.jobNumberLbl:orderDetail.jobNumberLbl}}: {{orderDetailsHeaderData?.jobNumber}}</p>
            <p>{{orderDetailTxt.cscPhoneLbl?orderDetailTxt.cscPhoneLbl:orderDetail.cscPhoneLbl}}: {{orderDetailsHeaderData?.cscPhone}}</p>
          </div>
          <div class="col-sm-4">
            <p>{{orderDetailTxt.poLbl?orderDetailTxt.soLbl:orderDetail.poLbl}}: {{OrderDetailsData?.poNumber}}</p> <p>{{orderDetailTxt.OrderDateLbl?orderDetailTxt.OrderDateLbl:orderDetail.OrderDateLbl}}: {{orderDetailsHeaderData?.orderDateUIString}}</p>
          </div>
          <div class="col-sm-4">
            <p>{{orderDetailTxt.shippingFromLbl?orderDetailTxt.shippingFromLbl:orderDetail.shippingFromLbl}}: {{OrderDetailsData?.shipFrom}}</p><p>{{orderDetailTxt.cscNameLbl?orderDetailTxt.cscNameLbl:orderDetail.cscNameLbl}}: {{orderDetailsHeaderData?.cscName}}</p>
          </div>
        </div>-->
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.soLbl?orderDetailTxt.soLbl:orderDetail.soLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.orderNumber}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.poLbl?orderDetailTxt.soLbl:orderDetail.poLbl}} :<span class="float-right-pwa"> {{OrderDetailsData?.poNumber}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.shippingFromLbl?orderDetailTxt.shippingFromLbl:orderDetail.shippingFromLbl}}: <span class="float-right-pwa">{{OrderDetailsData?.shipFrom}}</span></div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.jobNumberLbl?orderDetailTxt.jobNumberLbl:orderDetail.jobNumberLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.jobNumber}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.jobNameLbl?orderDetailTxt.jobNameLbl:orderDetail.jobNameLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.jobName}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.OrderDateLbl?orderDetailTxt.OrderDateLbl:orderDetail.OrderDateLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.orderDateUIString}}</span></div>


        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.cscNameLbl?orderDetailTxt.cscNameLbl:orderDetail.cscNameLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.cscName}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">{{orderDetailTxt.cscPhoneLbl?orderDetailTxt.cscPhoneLbl:orderDetail.cscPhoneLbl}}: <span class="float-right-pwa"> {{orderDetailsHeaderData?.cscPhone}}</span></div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero"></div>
        </div>
      </div>

    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{orderDetailTxt.billingAddressLbl?orderDetailTxt.billingAddressLbl:orderDetail.billingAddressLbl}}">
    <ng-template kendoTabContent>
      <div class="topGrid">
        <h4 class="fontInPwa">{{orderDetailTxt.billingAddressLbl?orderDetailTxt.billingAddressLbl:orderDetail.billingAddressLbl}}</h4>
        <div class="row marginLeft-pwa">
          <div class="col-sm-4">
            <p>
              {{billingAddress?.customerNumber}}-{{billingAddress?.customerName}}<br />
              {{billingAddress?.addressLine1}}{{billingAddress?.addressLine2}}<br />
              {{billingAddress?.city}},{{billingAddress?.state}} {{billingAddress?.zipCode}}
            </p><br />
          </div>
          <div class="col-sm-4">
          </div>
          <div class="col-sm-4">
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{orderDetailTxt.shippingAddressLbl?orderDetailTxt.shippingAddressLbl:orderDetail.shippingAddressLbl}}">
    <ng-template kendoTabContent>
      <div class="topGrid">
        <h4 class="fontInPwa">{{orderDetailTxt.shippingAddressLbl?orderDetailTxt.shippingAddressLbl:orderDetail.shippingAddressLbl}}</h4>
        <div class="row marginLeft-pwa">
          <div class="col-sm-4">
            <p>
              {{shippingAddress?.customerNumber}}-{{shippingAddress?.customerName}}<br />
              {{shippingAddress?.addressLine1}}{{shippingAddress?.addressLine2}}<br />
              {{shippingAddress?.city}},{{shippingAddress?.state}} {{shippingAddress?.zipCode}}
            </p><br />
          </div>
          <div class="col-sm-4">
          </div>
          <div class="col-sm-4">
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
<br />
<!--<kendo-tabstrip [scrollable]="true" [tabPosition]="position" (tabSelect)="onDetailsGridTabSelected($event)" >-->
  <kendo-tabstrip  [tabPosition]="position" (tabSelect)="onDetailsGridTabSelected($event)" class="k-tabstrip">

    <kendo-tabstrip-tab title="{{orderDetailTxt.orderDetailsLbl?orderDetailTxt.orderDetailsLbl:orderDetail.orderDetailsLbl}}" [selected]="true">
      <ng-template kendoTabContent>
        <kendo-grid [data]="orderDetailsTabGridData"
                    class="orderInquiryDetailsGridCls"
                    [sortable]="true"
                    [selectable]="false"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="true"
                    [sort]="orderDetailsGridstate.sort"
                    [pageable]="{ buttonCount: 5, info: true,responsive:true }"
                    [pageSize]="orderDetailsGridstate.take"
                    [skip]="orderDetailsGridstate.skip"
                    [columnMenu]="{ filter: false, sort: false }"
                    (sort)="orderDetailsGridSortChange($event)"
                    (pageChange)="orderDetailsGridPageChange($event)"
                    (dataStateChange)="orderDetailsDataStateChange($event)"
                    (columnReorder)="onReorder($event)"
                    (columnVisibilityChange)="onVisibilityChange($event)"
                    [filter]="orderDetailsGridstate.filter"
                    [loading]="orderDetailsLoading">
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
              <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
                {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
                <kendo-loader *ngIf="loadingExcel"></kendo-loader>
              </button>
              <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
                {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
                <kendo-loader *ngIf="loadingPDF"></kendo-loader>
              </button>
            </div>
            <input placeholder="Search in all columns..."
                   kendoTextBox
                   (input)="onFilterOrderInquiryDetails($event.target.value)" class="pwaOrderInquiryDetailsSearch" />
          </ng-template>

          <kendo-grid-column media="(max-width: 1024px)" title="Order Details">
            <ng-template kendoGridCellTemplate let-dataItem>
              <!--<span style="display:none;" *ngIf="position4 != 'top'">{{setTabPosition('top')}}</span>-->
              <div class="row mb-3">
                <div class="col-12 descriptionPwa">
                  co
                  
                  {{dataItem.itemNumber}} - {{dataItem.description}}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.qtyLbl ? orderDetailTxt.qtyLbl : orderDetail.qtyLbl}}:</span><span class="float-right-pwa"> {{dataItem.quantity}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.orderDateLbl ? orderDetailTxt.orderDateLbl : orderDetail.orderDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderDateUIString}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold"> {{orderDetailTxt.scheduleDateLbl ? orderDetailTxt.scheduleDateLbl : orderDetail.scheduleDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.scheduleDateUIString}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.uomLbl ? orderDetailTxt.uomLbl : orderDetail.uomLbl}}:</span><span class="float-right-pwa"> {{dataItem.uom}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.shipDateLbl ? orderDetailTxt.shipDateLbl : orderDetail.shipDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipDateUIString}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.listPriceLbl ? orderDetailTxt.listPriceLbl : orderDetail.listPriceLbl}}:</span><span class="float-right-pwa" *ngIf="dataItem.listPrice!='-0.001'"> {{dataItem.listPrice}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.multiplierLbl ? orderDetailTxt.multiplierLbl : orderDetail.multiplierLbl}}:</span><span class="float-right-pwa"> {{dataItem.cmp}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.paintLbl ? orderDetailTxt.paintLbl : orderDetail.paintLbl}}:</span><span class="float-right-pwa"> {{dataItem.paint}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.statusLbl ? orderDetailTxt.statusLbl : orderDetail.statusLbl}}:</span><span class="float-right-pwa"> {{dataItem.status}}</span>
                </div>
              </div>

            </ng-template>
            <ng-template kendoGridFooterTemplate>
              <div class="row">
                <div class="col-12 totalPrice" *ngIf="!hideOrderTotal">
                  {{orderTotal | currency}} -
                  {{orderDetailTxt.totalPriceLbl?orderDetailTxt.totalPriceLbl:orderDetail.totalPriceLbl}}
                </div>
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                             [field]="col.field"
                             [title]="col.title"
                             [width]="col._width"
                             [filter]="col.filter"
                             [filterable]="col.filterable"
                             [hidden]="col.hidden"
                             [format]="col.format" media="(min-width: 1025px)">

            <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'scheduleDateAsDate'">
              <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="scheduleDateAsDate">
              </app-grid-daterange-filter>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'shipDateAsDate'">
              <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="shipDateAsDate">
              </app-grid-daterange-filter>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'orderDateAsDate'">
              <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="orderDateAsDate">
              </app-grid-daterange-filter>
            </ng-template>-->
            <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'listPrice'">
              <div *ngIf="dataItem.listPrice!='-0.001' && dataItem.cmp != 0">
                {{(orderDetailsHeaderData.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" : dataItem.listPrice | currency}}
              </div>
            </ng-template>
            <ng-template kendoGridFooterTemplate *ngIf="col.field == 'listPrice'">
              <h4 class="orderTotalInGrid" *ngIf="!hideOrderTotal">
                {{orderTotal | currency}} -
                {{orderDetailTxt.totalPriceLbl?orderDetailTxt.totalPriceLbl:orderDetail.totalPriceLbl}}
              </h4>
            </ng-template>
            <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'cmp'">
              <div *ngIf="dataItem.cmp != 0">
                {{(orderDetailsHeaderData.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" : dataItem.cmp}}
              </div>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                         *ngIf="col.field == 'status'">
              <app-grid-dropdown-filter [filter]="filter" [data]="statusData" textField="name" valueField="status">
              </app-grid-dropdown-filter>
            </ng-template>
          </kendo-grid-column>
          <!--Need to remove commented code after varifying-->
          <!--<kendo-grid-column field="lineNumber"
                             title="{{orderDetailsTabGridColumnLbl.line}}" >
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="itemNumber"
                             title="{{orderDetailsTabGridColumnLbl.item}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="quantity"
                             title="{{orderDetailsTabGridColumnLbl.qty}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="uom"
                             title="{{orderDetailsTabGridColumnLbl.uom}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="orderDate"
                             title="{{orderDetailsTabGridColumnLbl.orderDate}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf = "col.field == 'orderDateForDisplay'">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="paint"
                             title="{{orderDetailsTabGridColumnLbl.paint}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="description"
                             title="{{orderDetailsTabGridColumnLbl.itemDecription}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="status"
                             title="{{orderDetailsTabGridColumnLbl.status}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="shipDate"
                             title="{{orderDetailsTabGridColumnLbl.shipDate}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="listPrice"
                             title="{{orderDetailsTabGridColumnLbl.listPrice}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="multiplier"
                             title="{{orderDetailsTabGridColumnLbl.multiplier}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--Not there in KD 4.0-->
          <!--<kendo-grid-column field="unitPrice"
                             title="{{orderDetailsTabGridColumnLbl.unitPrice}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="extendedPrice"
                             title="{{orderDetailsTabGridColumnLbl.extendedPrice}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <ng-template kendoGridNoRecordsTemplate>
          </ng-template>
          <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>-->
        </kendo-grid>

      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab title="{{orderDetailTxt.invoiceDetailsLbl?orderDetailTxt.invoiceDetailsLbl:orderDetail.invoiceDetailsLbl}}" *ngIf="hasInvoiceInquiryAccess">
      <ng-template kendoTabContent>
        <div class="topGrid">
          <h4 class="fontInPwa">{{orderDetailsHeaderData?.jobName}}</h4>
          <!--<div class="row">
            <div class="col-6 col-md-3 paddingZero">
              <p>{{orderDetailTxt.invoiceNumberLbl?orderDetailTxt.invoiceNumberLbl:orderDetail.invoiceNumberLbl}}: {{invoiceHeaderInfo?.invoiceNumber}}</p>
                  <p>{{orderDetailTxt.invoiceDateLbl?orderDetailTxt.invoiceDateLbl:orderDetail.invoiceDateLbl}}: {{invoiceHeaderInfo?.invoiceDateUIString}}</p>
              <p>{{orderDetailTxt.kdRefLbl?orderDetailTxt.kdRefLbl:orderDetail.kdRefLbl}}: {{invoiceHeaderInfo?.kdReferenceNumber}}</p>
            </div>

            <div class="col-6 col-md-3 paddingZero">
              <p>{{orderDetailTxt.grossAmountLbl?orderDetailTxt.grossAmountLbl:orderDetail.grossAmountLbl}}: {{invoiceHeaderInfo?.grossAmount  |currency}}</p>
                  <p>{{orderDetailTxt.openAmountLbl?orderDetailTxt.openAmountLbl:orderDetail.openAmountLbl}}: {{invoiceHeaderInfo?.openAmount  |currency}}</p>
              <p>{{orderDetailTxt.nonTaxableLbl?orderDetailTxt.nonTaxableLbl:orderDetail.nonTaxableLbl}}: {{invoiceHeaderInfo?.nonTaxableAmount  |currency}}</p>
            </div>
            <div class="col-6 col-md-3 paddingZero">
              <p>{{orderDetailTxt.taxableAmountLbl?orderDetailTxt.taxableAmountLbl:orderDetail.taxableAmountLbl}}: {{invoiceHeaderInfo?.taxableAmount  |currency}}</p>
                  <p>{{orderDetailTxt.taxLbl?orderDetailTxt.taxLbl:orderDetail.taxLbl}}: {{invoiceHeaderInfo?.tax  |currency}}</p>
            </div>
          </div>-->
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.invoiceNumberLbl?orderDetailTxt.invoiceNumberLbl:orderDetail.invoiceNumberLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.invoiceNumber}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.grossAmountLbl?orderDetailTxt.grossAmountLbl:orderDetail.grossAmountLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.grossAmount  |currency}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.taxableAmountLbl?orderDetailTxt.taxableAmountLbl:orderDetail.taxableAmountLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.taxableAmount  |currency}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.invoiceDateLbl?orderDetailTxt.invoiceDateLbl:orderDetail.invoiceDateLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.invoiceDateUIString}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.openAmountLbl?orderDetailTxt.openAmountLbl:orderDetail.openAmountLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.openAmount  |currency}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.taxLbl?orderDetailTxt.taxLbl:orderDetail.taxLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.tax  |currency}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.kdRefLbl?orderDetailTxt.kdRefLbl:orderDetail.kdRefLbl}}:
              <span class="float-right-pwa"> {{invoiceHeaderInfo?.kdReferenceNumber}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              {{orderDetailTxt.nonTaxableLbl?orderDetailTxt.nonTaxableLbl:orderDetail.nonTaxableLbl}}:
              <span class="float-right-pwa">  {{invoiceHeaderInfo?.nonTaxableAmount  |currency}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              <span class="float-right-pwa"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              <label style="margin-right: 3px;">{{orderDetailTxt.relatedInvoiceLbl?orderDetailTxt.relatedInvoiceLbl:orderDetail.relatedInvoiceLbl}}: </label>
              <kendo-dropdownlist style="width:11.9em" [data]="invoiceNumberList" [(ngModel)]="invoiceNum"
                                  textField="invoiceNumberWithSuffix" valueField="invoiceNumber" (valueChange)="invoiceNumberChange($event)"
                                  class="kendoInput relatedInvDDL float-right-pwa" [loading]="loadingRelatedInvoices">
              </kendo-dropdownlist>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              <span class="float-right-pwa"></span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
              <span class="float-right-pwa"></span>
            </div>
          </div>
        </div>

        <kendo-grid [data]="invoiceDetailsTabGridData"
                    class="orderInquiryDetailsGridCls"
                    [sortable]="true"
                    [selectable]="false"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="true"
                    [sort]="invoiceDetailsGridstate.sort"
                    [pageable]="{ buttonCount: 5, info: true,responsive:true, pageSizes:[50,75,100] }"
                    [pageSize]="invoiceDetailsGridstate.take"
                    [skip]="invoiceDetailsGridstate.skip"
                    [columnMenu]="{ filter: false, sort: false }"
                    (sort)="invoiceDetailsGridSortChange($event)"
                    (pageChange)="invoiceDetailsGridPageChange($event)"
                    (dataStateChange)="invoiceDetailsDataStateChange($event)"
                    (columnReorder)="onInvoiceReorder($event)"
                    (columnVisibilityChange)="onInvoiceVisibilityChange($event)"
                    [filter]="invoiceDetailsGridstate.filter"
                    [loading]="invoiceDetailsLoading">
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
              <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateInvoiceExcel()">
                {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
                <kendo-loader *ngIf="loadingExcel"></kendo-loader>
              </button>
              <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateInvoicePDF()">
                {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
                <kendo-loader *ngIf="loadingPDF"></kendo-loader>
              </button>
            </div>
            <input placeholder="Search in all columns..."
                   kendoTextBox
                   (input)="onFilterInvoiceDetails($event.target.value)" class="pwaOrderInquiryDetailsSearch" />
          </ng-template>
          <kendo-grid-column media="(max-width: 1024px)" title="Invoice Details">
            <ng-template kendoGridCellTemplate let-dataItem>

              <div class="row mb-3">
                <div class="col-12 descriptionPwa">
                  {{dataItem.itemNumber}} - {{dataItem.itemDescription}}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold descriptionPwa">{{orderDetailTxt.invoiceNumberLbl ? orderDetailTxt.invoiceNumberLbl : orderDetail.invoiceNumberLbl}}:</span> <span class="float-right-pwa"> {{dataItem.invoiceNumber}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold descriptionPwa">{{orderDetailTxt.qtyLbl ? orderDetailTxt.qtyLbl : orderDetail.qtyLbl}}:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.orderTypeLbl ? orderDetailTxt.orderTypeLbl : orderDetail.orderTypeLbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderType}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold"> {{orderDetailTxt.lineLbl ? orderDetailTxt.lineLbl : orderDetail.lineLbl}}:</span> <span class="float-right-pwa"> {{dataItem.lineNumber}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.uomLbl ? orderDetailTxt.uomLbl : orderDetail.uomLbl}}:</span> <span class="float-right-pwa"> {{dataItem.uom}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.unitPriceLbl ? orderDetailTxt.unitPriceLbl :orderDetail.unitPriceLbl}}:</span> <span class="float-right-pwa"> {{dataItem.unitPrice}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.extendedPriceLbl ? orderDetailTxt.extendedPriceLbl : orderDetail.extendedPriceLbl}}:</span> <span class="float-right-pwa"> {{dataItem.extendedPrice}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.shipFromLbl ? orderDetailTxt.shipFromLbl : orderDetail.shipFromLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipFrom}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.statusLbl ? orderDetailTxt.statusLbl : orderDetail.statusLbl}}:</span> <span class="float-right-pwa"> {{dataItem.status}}</span>
                </div>
              </div>

            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column *ngFor="let col of gridInvoiceSettings.columnsConfig"
                             [field]="col.field"
                             [title]="col.title"
                             [width]="col._width"
                             [filter]="col.filter"
                             [filterable]="col.filterable"
                             [hidden]="col.hidden"
                             [format]="col.format" media="(min-width: 1025px)">
            <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'unitPrice'">
              {{(dataItem.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" : dataItem?.unitPrice | currency}}
            </ng-template>
            <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'extendedPrice'">
              {{(dataItem.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" : dataItem?.extendedPrice | currency}}
            </ng-template>
          </kendo-grid-column>
          <!--<kendo-grid-column field="invoiceNumber"
                             title="{{invoiceDetailsTabGridColumnLbl.invoice}}"
                             [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="line"
                             title="{{invoiceDetailsTabGridColumnLbl.line}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="orderType"
                             title="{{invoiceDetailsTabGridColumnLbl.orderType}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="quantity"
                             title="{{invoiceDetailsTabGridColumnLbl.qty}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="uom"
                             title="{{invoiceDetailsTabGridColumnLbl.uom}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="item"
                             title="{{invoiceDetailsTabGridColumnLbl.item}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="description"
                             title="{{invoiceDetailsTabGridColumnLbl.description}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="unitPrice"
                             title="{{invoiceDetailsTabGridColumnLbl.unitPrice}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="extendedPrice"
                             title="{{invoiceDetailsTabGridColumnLbl.extendedPrice}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="shipFrom"
                             title="{{invoiceDetailsTabGridColumnLbl.shipFrom}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="status"
                             title="{{invoiceDetailsTabGridColumnLbl.status}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <ng-template kendoGridNoRecordsTemplate>
          </ng-template>
          <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>-->
        </kendo-grid>


      </ng-template>
    </kendo-tabstrip-tab>


    <kendo-tabstrip-tab title="{{orderDetailTxt.trackShipmentLbl?orderDetailTxt.trackShipmentLbl:orderDetail.trackShipmentLbl}}">
      <ng-template kendoTabContent>
        <!--Need to Apply accordian once data received-->
        <kendo-grid [data]="trackShipmentTabGridData"
                    class="orderInquiryDetailsGridCls"
                    [sortable]="true"
                    [selectable]="false"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="true"
                    [sort]="trackShipmentGridstate.sort"
                    [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
                    [pageSize]="trackShipmentGridstate.take"
                    [skip]="trackShipmentGridstate.skip"
                    [columnMenu]="{ filter: false, sort: false }"
                    (sort)="trackShipmentGridSortChange($event)"
                    (pageChange)="trackShipmentGridPageChange($event)"
                    (dataStateChange)="trackShipmentDataStateChange($event)"
                    (columnReorder)="onShipmentReorder($event)"
                    (columnVisibilityChange)="onShipmentVisibilityChange($event)"
                    [filter]="trackShipmentGridstate.filter"
                    [loading]="trackShipmentLoading">
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
              <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateShipmentExcel()">
                {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
                <kendo-loader *ngIf="loadingExcel"></kendo-loader>
              </button>
              <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateShipmentPDF()">
                {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
                <kendo-loader *ngIf="loadingPDF"></kendo-loader>
              </button>
            </div>
            <input placeholder="Search in all columns..."
                   kendoTextBox
                   (input)="onFilterTrackShipment($event.target.value)" class="pwaOrderInquiryDetailsSearch" />
          </ng-template>
          <kendo-grid-column media="(max-width: 1024px)" title="Track Shipment">
            <ng-template kendoGridCellTemplate let-dataItem>

              <div class="row mb-2">
                <div class="col-12 descriptionPwa">
                  {{dataItem.shipmentId}}- {{dataItem.carrier}}
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold descriptionPwa">{{orderDetailTxt.proNoLbl ? orderDetailTxt.proNoLbl : orderDetail.proNoLbl}}:</span> <span class="float-right-pwa"> {{dataItem.proNo}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold"> {{orderDetailTxt.noOfBoxesLbl ? orderDetailTxt.noOfBoxesLbl : orderDetail.noOfBoxesLbl}}:</span> <span class="float-right-pwa"> {{dataItem.noOfBoxes}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold"> {{orderDetailTxt.totalWeightLbl ? orderDetailTxt.totalWeightLbl : orderDetail.totalWeightLbl}}:</span> <span class="float-right-pwa"> {{dataItem.totalWeight}}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold descriptionPwa">{{orderDetailTxt.billOfLading ? orderDetailTxt.billOfLading : orderDetail.billOfLading}}:</span> <span class="float-right-pwa"> {{dataItem.billOfLoading}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero">
                  <span class="txt-bold">{{orderDetailTxt.shipDateLbl ? orderDetailTxt.shipDateLbl : orderDetail.shipDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipDateUIString | date:'M/dd/yyyy'}}</span>
                </div>
                <div class="col-sm-4 col-md-4 paddingZero"></div>
              </div>

            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column *ngFor="let col of gridShipmentSettings.columnsConfig"
                             [field]="col.field"
                             [title]="col.title"
                             [width]="col._width"
                             [filter]="col.filter"
                             [filterable]="col.filterable"
                             [hidden]="col.hidden"
                             [format]="col.format" media="(min-width: 1025px)">
          </kendo-grid-column>
          <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'shipDateUIString'">
            <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="shipDateUIString">
            </app-grid-daterange-filter>
          </ng-template>-->
          <!--<kendo-grid-column field="shipmentId"
                             title="{{trackShipmentTabGridColumnLbl.shipmentId}}"
                             [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="carrier"
                             title="{{trackShipmentTabGridColumnLbl.carrier}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="proNo"
                             title="{{trackShipmentTabGridColumnLbl.proNo}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="billOfLanding"
                             title="{{trackShipmentTabGridColumnLbl.billOfLading}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="noOfBoxes"
                             title="{{trackShipmentTabGridColumnLbl.noOfBoxes}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="totalWeight"
                             title="{{trackShipmentTabGridColumnLbl.totalWeight}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <!--<kendo-grid-column field="shipDateUIString"
                             title="{{trackShipmentTabGridColumnLbl.shipDate}}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>-->
          <ng-template kendoGridNoRecordsTemplate>
          </ng-template>
          <ng-template kendoGridDetailTemplate let-dataItem>
            <kendo-grid [data]="dataItem.trackChildShipments">
              <kendo-grid-column media="(max-width: 1024px)">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="row">
                    <div class="col-sm-4 col-md-4 paddingZero">
                      <span class="txt-bold descriptionPwa">Shipment ID:</span> <span class="float-right-pwa"> {{dataItem.shipmentid}}</span>
                    </div>
                    <div class="col-sm-4 col-md-4 paddingZero">
                      <span class="txt-bold descriptionPwa">Box No:</span> <span class="float-right-pwa"> {{dataItem.boxno}}</span>
                    </div>
                    <div class="col-sm-4 col-md-4 paddingZero">
                      <span class="txt-bold descriptionPwa">Item:</span> <span class="float-right-pwa"> {{dataItem.item}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-8 col-md-8 paddingZero">
                      <span class="txt-bold descriptionPwa">Item Description:</span> <span class="float-right-pwa"> {{dataItem.itemdescription}}</span>
                    </div>
                    <div class="col-sm-4 col-md-4 paddingZero">
                      <span class="txt-bold descriptionPwa">Quantity:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
                    </div>

                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="shipmentid" title="Shipment ID" media="(min-width: 1025px)">
              </kendo-grid-column>
              <kendo-grid-column field="boxno" title="Box No" media="(min-width: 1025px)">
              </kendo-grid-column>
              <kendo-grid-column field="item" title="Item" media="(min-width: 1025px)">
                >
              </kendo-grid-column>
              <kendo-grid-column field="itemdescription" title="Item Description" media="(min-width: 1025px)">
              </kendo-grid-column>
              <kendo-grid-column field="quantity" title="Quantity" media="(min-width: 1025px)">
              </kendo-grid-column>
            </kendo-grid>
          </ng-template>
          <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>-->
        </kendo-grid>

      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
